<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Logs de envio de SMS</strong>
        </div>
        <b-form @submit.stop.prevent>
          <b-form-group label="Telefone (código do país + DDD + número)" label-for="phone">
            <b-form-input id="phone" placeholder="Ex: 5511912345678" v-model="model.Receiver"></b-form-input>
          </b-form-group>

          <b-form-group label="Data Inicial" label-for="txt-data-inicio">
            <b-form-input type="date" id="txt-data-inicio" v-model="modelQuery.startDate"></b-form-input>
          </b-form-group>

          <b-form-group label="Data Final" label-for="txt-data-fim">
            <b-form-input type="date" id="txt-data-fim" v-model="modelQuery.endDate"></b-form-input>
          </b-form-group>

          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control mb-3" type="button" variant="success" @click="find"><i
                    class="fa fa-search"></i> Buscar</b-button>
              </b-col>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="danger" @click="clean">Limpar</b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
        <b-row>
          <b-col v-if="smsError != null || smsError != undefined" style="padding-top: 15px">
            <b-alert show variant="danger">
              {{ smsError }}
            </b-alert>
          </b-col>
        </b-row>
        <b-row>

          <b-col v-if="smsLogs.length > 1 || smsLogsBackup.length > 1" style="padding-top: 15px">
            <b-col sm="12" lg="2" class="input-group input-group-sm p-1">
              <input class="form-control input-txt" id="txt-search" type="text" name="txt-search"
                placeholder="Buscar na lista" v-on:keyup.enter="search" v-model="inputSearch">
              <span class="input-group-append">
                <button id="btn-search" class="btn btn-danger" type="button" title="Limpar busca" @click="clearSearch"
                  @click.stop.prevent>

                  <i class="fa fa-times"></i>
                </button>
                <button id="btn-search" class="btn btn-success" type="button" title="Buscar" @click="search"
                  @click.stop.prevent>
                  <i class="fa fa-search"></i>
                </button>

              </span>
            </b-col>

          </b-col>
        </b-row>
        <b-row>
          <!-- Search in array -->

          <b-col v-if="smsLogs.length > 0" style="padding-top: 15px">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Receptor</th>
                  <th scope="col">Data do Envio</th>
                  <th scope="col">Status</th>
                  <th scope="col">Remetente</th>
                  <th scope="col">Créditos</th>
                  <th scope="col">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in smsLogs" v-bind:key="index">
                  <th scope="row">{{ index }}</th>
                  <td>{{ item.Receiver }}</td>
                  <td>{{ formatDate(item.RequestDate) }}</td>
                  <td>{{ item.Status }}</td>
                  <td>{{ item.Sender }}</td>
                  <td>{{ item.Credits }}</td>
                  <!-- Eye -->
                  <td>
                    <b-button size="sm" v-b-modal.modalSmsLogger @click="actionModalSelect(item)" variant="info"><i
                        class="fa fa-eye"></i></b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-col v-if="smsLogs.length < 1 && smsSearching" style="padding-top: 15px;">
            <b-alert show variant="info">
              <p class="font-weight-bold mb-0">Nenhum registro encontrado</p>
            </b-alert>
          </b-col>
        </b-row>
        <b-modal id="modal-sms-loggs" ref="modalSmsLogger" title="Detalhes do SMS">
          <div>
            <p class="font-weight-bold">Cŕeditos : <span class="font-weight-normal ">{{ logModalSelected.Credits
                }}</span></p>
            <p class="font-weight-bold">Status : <span class="font-weight-normal ">{{ logModalSelected.Status }}</span>
            </p>
            <p class="font-weight-bold">Receptor : <span class="font-weight-normal ">{{ logModalSelected.Receiver
                }}</span></p>
            <p class="font-weight-bold">Data de Envio : <span class="font-weight-normal ">{{
      formatDate(logModalSelected.RequestDate) }}</span></p>
            <p class="font-weight-bold">Data de Agendamento : <span class="font-weight-normal ">{{
      formatDate(logModalSelected.ScheduleDate) }}</span></p>
            <p class="font-weight-bold">Remetente : <span class="font-weight-normal ">{{ logModalSelected.Sender
                }}</span></p>
            <p class="font-weight-bold">Mensagem : <span class="font-weight-normal ">{{ logModalSelected.SystemMessage
                }}</span></p>

          </div>
          <!-- code block -->
          <pre>{{ logModalSelected }}</pre>

          <!-- copy mensangem para área de transferencia -->
          <!-- <b-button variant="success" @click="copyToClipboard(logModalSelected)">Copiar Mensagem</b-button> -->


        </b-modal>

      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      phone: null,
      model: {
        Receiver: null,
      },
      modelQuery: {
        startDate: null,
        endDate: null
      },
      loadCount: 0,
      smsLogs: [],
      smsLogsBackup: [],
      smsSearching: false,
      smsError: null,
      inputSearch: '',

      logModalSelected: {
        Credits: 0,
        DlrStatus: '',
        Receiver: '',
        RequestDate: '',
        ScheduleDate: '',
        Sender: '',
        Status: '',
        SystemMessage: '',
      }
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    formatDate(date) {
      if (date == null || date == '') {
        return '';
      }
      return formatDate(date, "dd/MM/yyyy hh:mm:ss");
    },
    translateStatus(status) {
      let statuses = [
        { status: 'Error', translation: 'Erro' },
        { status: 'Delivered', translation: 'Entregue' },
        { status: 'Undelivered', translation: 'Não Entregue' },
        { status: 'Rejected', translation: 'Rejeitado' },
        { status: 'Failed', translation: 'Falha' }
      ];

      return statuses.find(s => s.status === status).translation;
    },
    clean() {
      const self = this;

      self.smsLogs = [];
      self.phone = '';
    },
    find() {
      var self = this;
      self.loadCount++;
      if (self.model.Receiver == null || self.model.Receiver == '') {
        alert('Informe o telefone');
        self.loadCount--;
        return;
      }
      //validar invervalo de 45 dias
      if (self.modelQuery.startDate && self.modelQuery.endDate) {
        var startDate = new Date(self.modelQuery.startDate);
        var endDate = new Date(self.modelQuery.endDate);
        var diff = Math.abs(startDate - endDate);
        var diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
        if (diffDays > 45) {
          self.smsError = 'Intervalo de datas não pode ser maior que 45 dias.';
          self.loadCount--;
          return;
        }
      }
      axios
        .get(`${env.urlBillingApi}/logs-sms/${self.model.Receiver ? self.model.Receiver : 'null'}`, { params: self.modelQuery })
        .then(function (response) {
          if (response.data.Success) {
            self.smsError = null;
            self.smsLogs = response.data.Object;
            self.smsLogsBackup = response.data.Object;
          }
          else if (response.data.Error) {
            self.smsError = response.data;
            self.smsError = response.data.response ? response.data.response : 'Erro ao buscar logs de SMS';
          }
        })
        .catch(function (error) {
          self.smsError = 'Erro ao buscar logs de SMS';
          if (error.response
            && error.response.data
            && error.response.data.detail
            && error.response.data.detail.messages
            && Array.isArray(error.response.data.detail.messages)
          ) {
            self.smsError = error.response.data.detail.messages[0].Message;
          }
          requestError(error);
        })
        .finally(() => {
          self.loadCount--;
          self.smsSearching = true;
        });
    },

    search() {
      var self = this;
      //save in backup
      self.smsLogsBackup = self.smsLogs;
      var filtered = self.smsLogs.filter(function (item) {
        return item.Receiver.includes(self.inputSearch);
      });
      self.smsLogs = filtered;
    },
    clearSearch() {
      var self = this;
      self.inputSearch = '';
      self.smsLogs = self.smsLogsBackup;
    },
    actionModalSelect(item) {
      this.$refs.modalSmsLogger.show();
      this.logModalSelected = item;

    }
  }
}
</script>
